// extracted by mini-css-extract-plugin
export default {"square672":"square_square672__FajD0","square1160":"square_square1160__RL6TO","square2125":"square_square2125__dXUi7"};